import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils/utils'

export type AngleRightSmallIconProps = {
  size?: number | string
  fillColor?: string
}

/**
 * Small right-pointing chevron (Aurora "angle-right-small"), used as a trailing icon on list rows
 */
export const AngleRightSmallIcon: FunctionComponent<AngleRightSmallIconProps> = ({ size = 24, fillColor }) => {
  const { colors } = useTheme()

  return (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' testID={tID('AngleRightSmallIcon')}>
      <Path
        d='M14.3543 12.3543L10.3543 16.3543C10.2563 16.4523 10.1283 16.5003 10.0003 16.5003C9.87225 16.5003 9.74425 16.4513 9.64625 16.3543C9.45125 16.1593 9.45125 15.8422 9.64625 15.6472L13.2922 12.0012L9.64625 8.35523C9.45125 8.16023 9.45125 7.8432 9.64625 7.6482C9.84125 7.4532 10.1583 7.4532 10.3533 7.6482L14.3533 11.6482C14.5493 11.8422 14.5493 12.1583 14.3543 12.3543Z'
        fill={fillColor || colors.iconDefault}
      />
    </Svg>
  )
}
